import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { PublicAssetMobileVersion } from "~/_app/(public-asset)/_components/PublicAssetMobileVersions";
import { MobileVersionsPanelWrapper } from "~/components/AssetModal/MobileTabNavigation/MobileVersionsPanelWrapper/MobileVersionsPanelWrapper";
export const PublicMobileVersionsPanelWrapper = /*#__PURE__*/ memo((param)=>{
    let { onClose } = param;
    return /*#__PURE__*/ _jsx(MobileVersionsPanelWrapper, {
        onClose: onClose,
        children: /*#__PURE__*/ _jsx(PublicAssetMobileVersion, {})
    });
});
PublicMobileVersionsPanelWrapper.displayName = "PublicMobileVersionsPanelWrapper";
